module.exports = __webpack_public_path__ + "static/media/fugl.b01602ce.mp3";